import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ov-suite-app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  ngOnInit(): void {}
}
